<template>
    <div class="d-flex flex-column align-end">
        <div class="d-flex align-baseline">
            <div class="white--text my-2 text-caption text-capilize">
                {{ nomeExibido }}
            </div>
            <v-btn x-small icon class="mx-2" color="white" @click="abrirMenu"
                ><v-icon>mdi-account-convert</v-icon></v-btn
            >
        </div>

        <v-btn small @click="logout"><v-icon>mdi-logout</v-icon>Sair</v-btn>

        <v-navigation-drawer
            v-model="menuAberto"
            right
            temporary
            fixed
            width="320"
            color="primary"
            dark
        >
            <v-list>
                <v-list-item>
                    <v-list-item-title class="text-subtitle-1 font-weight-bold">
                        {{ nomeExibido }}
                    </v-list-item-title>
                </v-list-item>
                <v-list-item v-if="estaAtuandoComoInstitucional">
                    <v-list-item-content>
                        <v-btn small outlined @click="voltar">
                            <v-icon left small>mdi-account-arrow-left</v-icon>
                            Voltar a ser eu mesmo
                        </v-btn>
                    </v-list-item-content>
                </v-list-item>
            </v-list>

            <v-divider></v-divider>

            <v-list>
                <v-subheader class="white--text">
                    Assumir usuário institucional
                </v-subheader>
                <v-list-item v-if="carregando">
                    <v-list-item-title>Carregando...</v-list-item-title>
                </v-list-item>
                <v-list-item
                    v-for="usuarioInstitucional in usuariosInstitucionais"
                    :key="usuarioInstitucional.id"
                    @click="assumir(usuarioInstitucional)"
                >
                    <v-list-item-content>
                        <v-list-item-title>
                            {{ usuarioInstitucional.nome }}
                        </v-list-item-title>
                        <v-list-item-subtitle>
                            {{ usuarioInstitucional.email }}
                        </v-list-item-subtitle>
                    </v-list-item-content>
                </v-list-item>
            </v-list>
        </v-navigation-drawer>
    </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { getServicoUsuarioInstitucional } from "../services/ServicosFactory";

export default {
    name: "DisplayUsuario",
    data() {
        return {
            menuAberto: false,
            usuariosInstitucionais: [],
            carregando: false,
        };
    },
    computed: {
        ...mapGetters("autenticacao", [
            "username",
            "cpf",
            "usuarioInstitucionalAtivo",
            "estaAtuandoComoInstitucional",
        ]),
        nomeExibido() {
            return this.estaAtuandoComoInstitucional
                ? `${this.username} (${this.usuarioInstitucionalAtivo.nome})`
                : this.username;
        },
    },
    methods: {
        ...mapActions("autenticacao", {
            logout: "LOGOUT",
            assumirUsuarioInstitucional: "assumirUsuarioInstitucional",
            voltarParaMeuUsuario: "voltarParaMeuUsuario",
        }),
        abrirMenu() {
            this.menuAberto = true;
            this.carregando = true;
            getServicoUsuarioInstitucional()
                .obterMeusUsuariosInstitucionais()
                .then((usuariosInstitucionais) => {
                    this.usuariosInstitucionais = usuariosInstitucionais;
                })
                .finally(() => {
                    this.carregando = false;
                });
        },
        assumir(usuarioInstitucional) {
            this.assumirUsuarioInstitucional(usuarioInstitucional);
            this.menuAberto = false;
        },
        voltar() {
            this.voltarParaMeuUsuario();
            this.menuAberto = false;
        },
    },
};
</script>
